import React from 'react';
import { Flex, Text, HStack, Box } from '@chakra-ui/react';
import { FaCaretLeft, FaCaretRight } from 'react-icons/fa';

export const Pagination = ({ pagination, onPageChange }) => {
  const { page, totalPages } = pagination;

  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1, 2, 3, 4);
      pages.push('...');
      pages.push(totalPages);
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <Flex justify="center" py={6} px={{ base: 4, md: 8 }}>
      <HStack spacing={4}>
        <Box
          as={FaCaretLeft}
          boxSize={8}
          color="brand.dkGray1"
          cursor={page <= 1 ? 'default' : 'pointer'}
          onClick={() => page > 1 && onPageChange(page - 1)}
          _hover={page > 1 ? { color: 'brand.ltRed' } : {}}
        />
        <Text
          fontSize="sm"
          color={page <= 1 ? 'brand.dkGray1' : 'brand.dkGray2'}
          cursor={page <= 1 ? 'default' : 'pointer'}
          onClick={() => page > 1 && onPageChange(page - 1)}
          _hover={page > 1 ? { color: 'brand.ltRed' } : {}}
          fontWeight="500"
        >
          PREV
        </Text>

        {pageNumbers.map((num, idx) => (
          num === '...' ? (
            <Text key={`ellipsis-${idx}`} fontSize="sm" color="brand.dkGray2">
              ...
            </Text>
          ) : (
            <Box
              key={num}
              as="button"
              w={7}
              h={7}
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize="sm"
              fontWeight="500"
              bg={page === num ? 'brand.dkGray1' : 'transparent'}
              color={page === num ? 'brand.white' : 'brand.dkGray2'}
              borderRadius="sm"
              cursor="pointer"
              _hover={{
                color: page === num ? 'brand.white' : 'brand.ltRed'
              }}
              onClick={() => onPageChange(num)}
            >
              {num}
            </Box>
          )
        ))}

        <Text
          fontSize="sm"
          color={page >= totalPages ? 'brand.dkGray1' : 'brand.dkGray2'}
          cursor={page >= totalPages ? 'default' : 'pointer'}
          onClick={() => page < totalPages && onPageChange(page + 1)}
          _hover={page < totalPages ? { color: 'brand.ltRed' } : {}}
          fontWeight="500"
        >
          NEXT
        </Text>
        <Box
          as={FaCaretRight}
          boxSize={8}
          color="brand.dkGray1"
          cursor={page >= totalPages ? 'default' : 'pointer'}
          onClick={() => page < totalPages && onPageChange(page + 1)}
          _hover={page < totalPages ? { color: 'brand.ltRed' } : {}}
        />
      </HStack>
    </Flex>
  );
};
